import { SchemaTypes } from '@allesauto/graphql';
import { FC } from 'react';

export interface DealerAddressProps {
  dealer: SchemaTypes.Dealer;
  showDealerName?: boolean;
  className?: string;
}

const DealerAddress: FC<React.PropsWithChildren<DealerAddressProps>> = ({
  dealer,
  showDealerName = false,
  className,
}) => {
  return (
    <div className={className}>
      {showDealerName && (
        <div className="font-weight-bold mb-15px">{dealer.name}</div>
      )}
      <div>
        {dealer.location?.street ?? ''} {dealer.location?.houseNumber ?? ''}{' '}
      </div>
      <div>{dealer.location?.additionalAddress ?? ''}</div>
      <div>
        {dealer.location?.zip ?? ''} {dealer.location?.city ?? ''}
      </div>
    </div>
  );
};

export default DealerAddress;
